import AlertDayOfWeek from 'enums/AlertDayOfWeek'
import AlertDayOfMonth from 'enums/AlertDayOfMonth'
import AlertFrequency from 'enums/AlertFrequency'
import { ScheduledReport } from 'features/scheduledReport/types'

export const dayOfWeek = [...Object.values(AlertDayOfWeek).slice(1), AlertDayOfWeek.SUNDAY]

export const dayOfWeekMap = {
  [AlertDayOfWeek.MONDAY]: 'monday',
  [AlertDayOfWeek.TUESDAY]: 'tuesday',
  [AlertDayOfWeek.WEDNESDAY]: 'wednesday',
  [AlertDayOfWeek.THURSDAY]: 'thursday',
  [AlertDayOfWeek.FRIDAY]: 'friday',
  [AlertDayOfWeek.SATURDAY]: 'saturday',
  [AlertDayOfWeek.SUNDAY]: 'sunday'
}

export const dayOfMonth = {
  [AlertDayOfMonth.FIRST]: '1st',
  [AlertDayOfMonth.FIFTEENTH]: '15th',
  [AlertDayOfMonth.LAST]: 'last'
} as const

export const hours = Array.from({ length: 24 }, (_, i) => i)

export const FREQUENCY_OFF = 'Off'

export const frequency = {
  [FREQUENCY_OFF]: 'off',
  [AlertFrequency.TWICE_DAILY]: 'twiceDaily',
  [AlertFrequency.DAILY]: 'daily',
  [AlertFrequency.WEEKLY]: 'weekly',
  [AlertFrequency.MONTHLY]: 'monthly'
} as const

export const getCleanedData = (data: ScheduledReport) => {
  const transformedData = { ...data }
  switch (data.frequency) {
    case AlertFrequency.DAILY:
      transformedData.alertHourSecond = 0
      transformedData.dayOfWeek = AlertDayOfWeek.MONDAY
      transformedData.dayOfMonth = AlertDayOfMonth.FIRST
      return transformedData
    case AlertFrequency.TWICE_DAILY:
      transformedData.dayOfWeek = AlertDayOfWeek.MONDAY
      transformedData.dayOfMonth = AlertDayOfMonth.FIRST
      return transformedData
    case AlertFrequency.WEEKLY:
      transformedData.alertHourSecond = 0
      transformedData.dayOfMonth = AlertDayOfMonth.FIRST
      return transformedData
    case AlertFrequency.MONTHLY:
      transformedData.alertHourSecond = 0
      transformedData.dayOfWeek = AlertDayOfWeek.MONDAY
      return transformedData
    default:
      return transformedData
  }
}
